import { Record } from 'immutable';
import get from 'immutable-less/transmute/get';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import * as CRMObjectTypes from 'automation-ui-references/object-types/CRMObjectTypes';
import ClassicCopyCompanyPropertyActionMetadataKeys from 'automation-ui-action-features/actions/classic-copy-company-property/constants/ClassicCopyCompanyPropertyActionMetadataKeys';
export default class ClassicCopyCompanyPropertyActionMetadata extends Record({
  [ClassicCopyCompanyPropertyActionMetadataKeys.ACTION_TYPE]: ActionTypes.CLASSIC_COPY_COMPANY_PROPERTY,
  [ClassicCopyCompanyPropertyActionMetadataKeys.SOURCE_PROPERTY]: null,
  [ClassicCopyCompanyPropertyActionMetadataKeys.TARGET_PROPERTY]: null,
  [ClassicCopyCompanyPropertyActionMetadataKeys.TARGET_OBJECT]: CRMObjectTypes.CONTACT
}, 'ClassicCopyCompanyPropertyActionMetadata') {
  getSourceProperty() {
    return get(ClassicCopyCompanyPropertyActionMetadataKeys.SOURCE_PROPERTY, this);
  }
  getTargetProperty() {
    return get(ClassicCopyCompanyPropertyActionMetadataKeys.TARGET_PROPERTY, this);
  }
  getTargetObject() {
    return get(ClassicCopyCompanyPropertyActionMetadataKeys.TARGET_OBJECT, this);
  }
}